//
// class for number data type
//
// @extends [DataFormatterType]
//
import { DataFormatterType } from '../DataFormatterType';
import { DataFormatterOptions } from '../DataFormatterType';
import { DataTools } from '../../utils/DataTools';
import { Localizer } from '../../localize/localizer';

import { DataFormatNumber } from './DataFormatNumber';

// See Numeral.js - http://numeraljs.com/
import numeral from 'numeral';

/**
 * Data formatter for percent types.
 * Data stored as a decimal and displayed as a percent.
 * @ignore
 */
export class DataFormatPercent extends DataFormatNumber
{
    getName() : string
    {
        return "percent";
    }

    /* Currency is stored internally as USD */
    getUnitText(options ?: DataFormatterOptions) : string
    {
        return " %";
    }

    /* Default options for the number formatter */
    initializeOptions() : DataFormatterOptions
    {
        return {
            format: "#,###.##"
        }
    }

    /*
    Format data as a number.
    Options can have format='<numeral js template>'
    */
    format(data: any, options?: DataFormatterOptions, refObj?: any): string
    {
        let result = DataTools.getNumber(data);
        let formatValue = numeral(result).format("#,###.[##]");

        // const myOptions : DataFormatterOptions = this.getOptions(options);
        // const formatValue = super.format(data, options, refObj);

        // do we want to adjust the value in any way?
        return formatValue;
    }

    unformat(data: any) : any
    {
        if (data === undefined) return undefined;
        if (data === null) return undefined;
        if (typeof data === "string" && data === "") return undefined;

        let result = DataTools.getNumber(data);
        return result;
    }

}

export default DataFormatPercent;
